import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { NavComponent} from './core/nav/nav.component';
import { HomeComponent } from './home/home.component';
import { AppRoutingModule} from './core/app-routing.module';
import { SearchComponent } from './home/search/search.component';
import { SubmissionService } from './submission.service';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MaterializeModule} from 'angular2-materialize';
import { SubmissionDetailsComponent } from './submission-details/submission-details.component';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { HorizontalTimelineComponent } from './submission-details/horizontal-timeline/horizontal-timeline.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AbsolutePipe } from './utils/absolute.pipe';
import { StatsCardComponent } from './submission-details/stats-card/stats-card.component';
import { NumstringPipe } from './utils/numstring.pipe';
import { ErrorComponent } from './core/error/error.component';
import { MetaMetricsComponent } from './home/meta-metrics/meta-metrics.component';
import { MetadataService } from './metadata.service';
import { CurrentPostsComponent } from './current-posts/current-posts.component';
import { DonationComponent } from './donation/donation.component';
import { DonationCardComponent } from './donation/donation-card/donation-card.component';
import {ClipboardModule} from 'ngx-clipboard';
import { FooterComponent } from './core/footer/footer.component';
import { LeaderboardComponent } from './home/leaderboard/leaderboard.component';
import {AdsenseModule} from 'ng2-adsense';
import { AdComponent } from './ad/ad.component';
import { OtherPostsComponent } from './submission-details/other-posts/other-posts.component';

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    HomeComponent,
    SearchComponent,
    SubmissionDetailsComponent,
    HorizontalTimelineComponent,
    AbsolutePipe,
    StatsCardComponent,
    NumstringPipe,
    ErrorComponent,
    LeaderboardComponent,
    MetaMetricsComponent,
    CurrentPostsComponent,
    DonationComponent,
    DonationCardComponent,
    FooterComponent,
    AdComponent,
    OtherPostsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MaterializeModule,
    ChartsModule,
    BrowserAnimationsModule,
    ClipboardModule,
    AdsenseModule.forRoot({
      adClient: 'ca-pub-4726807445608817',
      adSlot: 1046247731,
      layout: 'in-article',
      adFormat: '\'fluid\'',
      display: '\'block\''

    })
  ],
  providers: [SubmissionService, MetadataService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/app.module.ts